export default class PressHelper {
  public static defaultImageSizeCropSm = '-w_545_h_327_crop';
  public static defaultImageSizeCropMd = '-w_350_h_212_crop';
  public static defaultImageSizeCropLg = '-w_300_h_175_crop';

  public static addSizePropertiesToImageUrl(url: string, imageSize: string): string {
    return url.replace(/.jpg|.png/gi, `${imageSize}$&`); // can be lower and uppercase
  }
}
